// UT30 is an unique code to identify each widget in the BPPR ecosystem
export const UT30SevOneBenefitsCalc = '30AHI';
